import { render, staticRenderFns } from "./MinorCardDocumentation.vue?vue&type=template&id=f13849b8&scoped=true&"
import script from "./MinorCardDocumentation.vue?vue&type=script&lang=js&"
export * from "./MinorCardDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./MinorCardDocumentation.vue?vue&type=style&index=0&id=f13849b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13849b8",
  null
  
)

export default component.exports